module.exports = __webpack_public_path__ + "8ce87dc6e3229bfb0a681a4138be88c5.png";